import React, { useState, useEffect } from "react";
import "../components/styles/SubscriptionModal.scss";
import { subscriptionModalReducer, activeSubscriptionReducer } from "../redux/slice/subscriptionSlice";
import { useDispatch, useSelector } from "react-redux";
import { purchasePackage, cancelSubscription, fetchPurchaseHistory } from "../redux/subscriptionApis";
import TextInput from "./formInputs/textInput";
import { TOAST, EMAIL_REGEXP } from '../../utils/constants';

function SubscriptionModal() {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [email, setEmail] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const location = window.location.pathname;
  // console.debug(`[SubscriptionModal] Current location: ${location}`);
  const closeModal = async () => {
    dispatch(subscriptionModalReducer({ isOpen: false }));
    setSelectedOption(null);
    setIsConfirmed(false);
    setEmail("");
    setEmailTouched(false);
  };

  const { productId, productPrice, productName, currency, paymentInitiated, activeSubscription, hasSubscriptionTypes, isMTN } = useSelector(
    (state) => state.fetchPackages
  );

  // Check if the selected operator is MTN or OTHERS
  const selectedOperator = JSON.parse(localStorage.getItem('afri_selected_operator') || '{}');
  const isOperatorMTN = isMTN !== undefined ? isMTN : (selectedOperator.username_prefix?.includes('amngh') || false);
  
  // Get the correct Plan ID based on operator and subscription type
  const getOperatorId = (subscriptionType = null) => {
    if (typeof productId === 'object' && productId !== null) {
      const operatorKey = isOperatorMTN ? 'mtn' : 'other';
      const operatorId = productId[operatorKey];
      
      // Handle nested structure for auto-renewal/on-demand
      if (typeof operatorId === 'object' && operatorId !== null) {
        if (subscriptionType) {
          return operatorId[subscriptionType] || operatorId['auto-renewal'];
        }
        return operatorId;
      }
      return operatorId;
    }
    return productId;
  };

  // Check if this plan has auto-renewal and on-demand options
  const checkHasSubscriptionTypes = () => {
    if (hasSubscriptionTypes !== undefined) {
      return hasSubscriptionTypes;
    }
    
    if (typeof productId === 'object' && productId !== null) {
      const operatorKey = isOperatorMTN ? 'mtn' : 'other';
      const operatorId = productId[operatorKey];
      return typeof operatorId === 'object' && operatorId !== null && 
             operatorId['auto-renewal'] && operatorId['on-demand'];
    }
    return false;
  };

  const hasOptions = checkHasSubscriptionTypes();

  // Debug: compute disabled state for the 'Yes' button and log it
  const isYesDisabled = !activeSubscription && (!email || !EMAIL_REGEXP.test(email));

  // useEffect(() => {
  //   // Log detailed debug info to help trace why the button is disabled/enabled
  //   console.debug('[SubscriptionModal] Yes button disabled state:', {
  //     isYesDisabled,
  //     activeSubscription,
  //     email,
  //     emailValid: EMAIL_REGEXP.test(email),
  //   });
  // }, [isYesDisabled, activeSubscription, email]);

  // Continue button disabled state for non-options modal
  const isContinueDisabled = !paymentInitiated && !activeSubscription && (!email || !EMAIL_REGEXP.test(email));

  // useEffect(() => {
  //   console.debug('[SubscriptionModal] Continue button disabled state:', {
  //     isContinueDisabled,
  //     paymentInitiated,
  //     activeSubscription,
  //     email,
  //     emailValid: EMAIL_REGEXP.test(email)
  //   });
  // }, [isContinueDisabled, paymentInitiated, activeSubscription, email]);

  const subscriber_uid = window.localStorage.getItem("afri_username");
  const title = paymentInitiated
    ? `Your subscription has been initiated.....`
    : `Are You Sure You Want to ${
        location.includes('subscription-history') ? "Cancel Your Subscription" : "Continue"
      }?`;

  const _initPurchasePackage = () => {
    const planId = typeof productId === 'number' ? productId : getOperatorId();

    // Debug: log values to trace why Continue might not trigger the purchase
    // try {
    //   console.debug('[SubscriptionModal] _initPurchasePackage called', {
    //     productId,
    //     planId,
    //     subscriber_uid,
    //     email,
    //     emailValid: EMAIL_REGEXP.test(email),
    //     activeSubscription,
    //     isOperatorMTN,
    //     selectedOperator: JSON.parse(window.localStorage.getItem('afri_selected_operator') || '{}')
    //   });
    // } catch (err) {
    //   console.debug('[SubscriptionModal] _initPurchasePackage - error serializing selectedOperator', err.message);
    // }

    
      if (location.includes('subscription-history')) {
      // No email needed for cancellation
      cancelSubscription(planId);
      window.localStorage.removeItem('premiumSub');
    } else {
      // Email validation only for purchase
      setEmailTouched(true);

      if (!email || !EMAIL_REGEXP.test(email)) {
        TOAST.error("Enter a valid email and click continue");
        return;
      }

      purchasePackage(planId, subscriber_uid, email);
    }
    
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsConfirmed(false);
    setEmail("");
    setEmailTouched(false);
  };

  const confirmSelection = () => {
    const planId = getOperatorId(selectedOption);
    
    if (location.includes('subscription-history')) {
      // No email needed for cancellation
      setIsConfirmed(true);
      cancelSubscription(planId);
      window.localStorage.removeItem('premiumSub');
    } else {
      // Email validation only for purchase
      setEmailTouched(true);
      
      if (!email || !EMAIL_REGEXP.test(email)) {
        TOAST.error("Enter a valid email and click yes");
        return;
      }
      
      setIsConfirmed(true);
      purchasePackage(planId, subscriber_uid, email);
    }
  };

  const _homeRedirect = () => {
    window.location.href = "/home";
  };

  // Get operator-specific IDs for rendering buttons
  const operatorIds = getOperatorId();
  const showAutoRenewal = hasOptions && typeof operatorIds === 'object' && operatorIds['auto-renewal'];
  const showOnDemand = hasOptions && typeof operatorIds === 'object' && operatorIds['on-demand'];

  return (
    hasOptions ? (
      <div className="modalBackground">
        <div className="modalContainer">
          <div className="titleCloseBtn">
            {!paymentInitiated && <button onClick={closeModal}>&#10006;</button>}
          </div>
          {selectedOption && !isConfirmed ? (
            <div className="confirmation">
              <div className="title">
                <h1>Are you sure you want to continue with the {selectedOption} option?</h1>
                 <p>You will be billed {currency} {productPrice} for the {productName} subscription</p>
              </div>
            
                <div className="body">
                  <TextInput
                    placeholder="Email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    error={emailTouched && (!email || !EMAIL_REGEXP.test(email))}
                    errorMessage={emailTouched && (!email || !EMAIL_REGEXP.test(email)) ? "Enter a valid email" : undefined}
                  />
                </div>
          
              <div className="footer">
                <button 
                  onClick={confirmSelection}
                  disabled={isYesDisabled}
                >
                  Yes
                </button>
                <button className="cancelBtn" onClick={() => {
                  setSelectedOption(null);
                  setEmail("");
                  setEmailTouched(false);
                }}>No</button>
              </div>
            </div>
          ) : (
            <>
              <div className="title">
                <h1>You have selected the {productName} Pack for {currency} {productPrice}</h1>
              </div>
              <div className="footer">
                {showAutoRenewal && (
                  <button onClick={() => handleOptionSelect("auto-renewal")}>
                    Auto-Renewal
                  </button>
                )}
                {showOnDemand && (
                  <button onClick={() => handleOptionSelect("on-demand")}>
                    On-Demand
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    ) : (
      <div className="modalBackground">
        <div className="modalContainer">
          <div className="titleCloseBtn">
            {!paymentInitiated && <button onClick={closeModal}>&#10006;</button>}
          </div>
          <div className="title">
            <h1>{title}</h1>
            {!paymentInitiated && !activeSubscription && (
              <p>You will be billed {currency} {productPrice} for the {productName} subscription</p>
            )}
          </div>
          
           {!location.includes('subscription-history') &&
            <div className="body">
              <TextInput
                placeholder="Email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                error={emailTouched && (!email || !EMAIL_REGEXP.test(email))}
                errorMessage={emailTouched && (!email || !EMAIL_REGEXP.test(email)) ? "Enter a valid email" : undefined}
              />
            </div>}
        
          <div className="footer">
            {!paymentInitiated && (
              <button
                onClick={() => {
                  closeModal();
                }}
                className="cancelBtn"
              >
                Cancel
              </button>
            )}
            <button
              onClick={paymentInitiated ? _homeRedirect : _initPurchasePackage}
              disabled={isContinueDisabled}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    )
  );
}

export default SubscriptionModal;